"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function useLogOnChange(react, label, dependency) {
    react.useEffect(() => {
        console.log(label, typeof dependency === 'object' ? JSON.stringify(dependency, null, '  ') : dependency);
    }, [label, dependency]);
}
exports.default = useLogOnChange;
